<div
  *ngIf="quickLinksData && (this.overlayActive === true || this.overlay === false)"
  class="cards"
  [ngClass]="pageConfig?.isUsingHtmlStructure ? '' : 'position-absolute-fill'"
  [ngClass]="isAllowedGlobalStyling ? '' : 'h-100 w-100'"
>
  <div class="divStyle pointer-events-none h-100">
    <finxone-web-frontend-quick-links
      [quickLinksData]="quickLinksData"
      [contentStyle]="contentStyle"
      [textContentStyle]="textContentStyle"
      [iconStyle]="iconStyle"
      [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      [globalStylingClass]="globalStylingClass"
      [activationDelaySeconds]="activationDelaySeconds"
    ></finxone-web-frontend-quick-links>
  </div>
</div>
